import {FormatDateOptions} from 'react-intl';

export const TEXT = {
  TOAST_SUCCESS_CANCEL: {id: 'account.currentLK.cancel_toast_success'},
  TOAST_ERROR: {id: 'account.currentLK.toast_error'},
  MODAL_ORDER_TITLE: {id: 'account.currentLK.cancel_title'},
  MODAL_ORDER_CANCEL_DESCRIPTION: {id: 'account.currentLK.cancel_paragraph_cancel'},
  MODAL_ORDER_CANCEL_CTA: {id: 'account_yourPlan.cancelOrder.cancelCta'},
  MODAL_ORDER_CANCEL_ACTION: {id: 'account_yourPlan.cancelOrder.continueCta'},
};

export const IDS = {
  CANCEL_ORDER_BUTTON: 'CancelOrdercta',
};

export const DATE_FORMAT: FormatDateOptions = {month: 'long', day: '2-digit', weekday: 'long'};
